// =============================================================================
// MeuDriver — Hook de onboarding guiado (I3)
// =============================================================================

import { useState, useEffect } from 'react'

const STORAGE_KEY = 'onboarding_done'
const TOTAL_STEPS = 5

export function useOnboarding() {
  const [showTour, setShowTour] = useState(false)
  const [step, setStep] = useState(0)

  useEffect(() => {
    const done = localStorage.getItem(STORAGE_KEY)
    if (!done) setShowTour(true)
  }, [])

  const completeTour = () => {
    localStorage.setItem(STORAGE_KEY, '1')
    setShowTour(false)
    setStep(0)
  }

  const skipTour = () => completeTour()

  const nextStep = () => {
    if (step < TOTAL_STEPS - 1) {
      setStep((s) => s + 1)
    } else {
      completeTour()
    }
  }

  const prevStep = () => {
    if (step > 0) setStep((s) => s - 1)
  }

  return {
    showTour,
    step,
    setStep,
    nextStep,
    prevStep,
    completeTour,
    skipTour,
    totalSteps: TOTAL_STEPS,
  }
}
